export const getSignupHcaptchaSiteKey = (): string =>
  String(import.meta.env.VITE_HCAPTCHA_SITE_KEY ?? '').trim();
